import { Action } from '@app/shared/ui/molecules/Diamonds';

export function ActionsSection() {
  return (
    <section className="mx-auto flex w-full max-w-[350px] justify-between px-3">
      <Action type="deposit" />
      <Action type="transfer" />
      <Action type="withdrawal" />
    </section>
  );
}
